import { defineStore } from 'pinia'
import { globalUnreadMessages } from './core/runtime'
import { initActions } from './core/initActions'
import { chatListActions } from './core/chatListActions'
import { employeeActions } from './core/employeeActions'
import { dialogActions } from './core/dialogActions'
import { unreadActions } from './core/unreadActions'
import { openChatActions } from './core/openChatActions'
import { messageActions } from './core/messageActions'
import { reactionActions } from './core/reactionActions'
import { useUserStore } from '@/modules/user/stores/userStore'
import { resolveActiveMessageRoomId } from '@/modules/chat-matrix-fast/utils/topics'
import { CHAT_LIST_TAB, CHAT_LIST_TYPES } from '@/modules/chat-matrix-fast/constants/chat'
import type { IChatStoreState } from '@/modules/chat-matrix-fast/types/IChat'

export const useChatStore = defineStore('matrixChatStoreFast', {
  state: (): IChatStoreState => ({
    chatDirectories: [],
    rootChatDirectoryIds: [],
    ungroupedChatIds: [],
    chatCatalogLoaded: false,
    chatCatalogError: null,
    chatCatalogRequestId: 0,
    chats: [],
    currentChatListTypes: CHAT_LIST_TYPES[CHAT_LIST_TAB.EMPLOYEES],
    currentChat: null,
    activeTopic: null,
    selectedTopicsGroupId: null,
    showTopicsList: false,
    messages: [],
    messagesByRoomId: new Map(),
    reactionTypes: [],
    reactionTypesLoaded: false,
    isSending: false,
    searchResults: null,
    isSearching: false,

    isInitialized: false,
    isInitializing: false,
    needsMatrixAuth: false,
    matrixAuthError: null as string | null,

    invitations: [],
    pendingReactionOverrides: {},
  }),

  actions: {
    ...initActions,
    ...chatListActions,
    ...employeeActions,
    ...dialogActions,
    ...unreadActions,
    ...openChatActions,
    ...messageActions,
    ...reactionActions,
  },

  getters: {
    /** Room для timeline / send: активная тема или основная комната чата */
    activeMessageRoomId(state): string | undefined {
      return resolveActiveMessageRoomId(state)
    },

    totalUnreadCount: state =>
      state.chats.reduce((total, chat) => total + (chat.unread_count || 0), 0),

    titleUnreadCount: () => globalUnreadMessages.unreadCount.value,

    currentUserId(): string | null {
      const userStore = useUserStore()

      return userStore.user?.uuid || userStore.user?.id?.toString() || null
    },

    chatsByType: state => (type: string) => {
      if (type === 'all') {
        return state.chats
      }
      if (type === 'direct') {
        return state.chats.filter(
          chat => chat.type === 'direct' || chat.type === 'dialog',
        )
      }

      return state.chats.filter(chat => chat.type === type)
    },

    unreadChats: state =>
      state.chats.filter(chat => (chat.unread_count || 0) > 0),

    activeChats: state => state.chats.filter(chat => chat.last_message_id),
  },
})
